import fetch from '@/utils/fetch'

// 獲取簡訊狀態
export function getaliSmsStatus () {
  return fetch({
    url: `/aliyunsms/status`,
    method: 'get'
  })
}

// 基礎配置

export function getSmsConfig (params = {}) {
  return fetch({
    url: `/aliyunsms/config`,
    method: 'get',
    params
  })
}
// 修改基礎配置
export function setSmsConfig (params = {}) {
  return fetch({
    url: `/aliyunsms/config`,
    method: 'post',
    params
  })
}

// 修改阿里簡訊狀態
export function setAlisms (params = {}) {
  return fetch({
    url: `/aliyunsms/status`,
    method: 'post',
    params
  })
}

export function setTheNewSignature (params = {}) {
  return fetch({
    url: '/aliyunsms/sign/add',
    method: 'post',
    params
  })
}

export function getTheSignature (params) {
  return fetch({
    url: `/aliyunsms/sign/info`,
    method: 'get',
    params
  })
}

export function editTheSignature (params) {
  return fetch({
    url: `/aliyunsms/sign/modify`,
    method: 'post',
    params
  })
}

export function deleteTheSignature (id) {
  return fetch({
    url: `/aliyunsms/sign/delete/${id}`,
    method: 'delete'
  })
}

// 傳送簡訊

// 簡訊場景列表
export function getScenarioList (params = {}) {
  return fetch({
    url: `/aliyunsms/scene/list`,
    method: 'get',
    params
  })
}

// 停用簡訊場景
export function offDisablingSms (params) {
  return fetch({
    url: `/aliyunsms/scene/disableItem`,
    method: 'get',
    params
  })
}

// 啟用簡訊場景
export function onDisablingSms (params) {
  return fetch({
    url: `/aliyunsms/scene/enableItem`,
    method: 'get',
    params
  })
}

// 刪除簡訊場景
export function deletedDisablingSms (id) {
  return fetch({
    url: `/aliyunsms/scene/deleteItem/${id}`,
    method: 'delete'
  })
}

// 簡訊簽名列表
export function getSmsSignatureList (params) {
  return fetch({
    url: `/aliyunsms/sign/list`,
    method: 'get',
    params
  })
}

// 簡訊模板列表
export function getSmsTemplateList (params) {
  return fetch({
    url: `/aliyunsms/template/list`,
    method: 'get',
    params
  })
}

// 新增簡訊場景條目
export function addSceneItem (params) {
  return fetch({
    url: `/aliyunsms/scene/addItem`,
    method: 'post',
    params
  })
}

// 簡訊模板

// 簽名模板列表
export function getTemplateList (params = {}) {
  return fetch({
    url: `/aliyunsms/template/list`,
    method: 'get',
    params
  })
}

// 下拉簡訊場景列表
export function getTemplateSeleteList (params = {}) {
  return fetch({
    url: `/aliyunsms/scene/simpleList`,
    method: 'get',
    params
  })
}

// 簡訊場景內容label
export function getTemplateContentLabel (params = {}) {
  return fetch({
    url: `/aliyunsms/scene/detail`,
    method: 'get',
    params
  })
}

// 新增簡訊模板
export function addSmsTemplate (params = {}) {
  return fetch({
    url: `/aliyunsms/template/add`,
    method: 'post',
    params
  })
}

// 簡訊模板detail
export function SmsTemplateDetail (params = {}) {
  return fetch({
    url: `/aliyunsms/template/info`,
    method: 'get',
    params
  })
}

// 修改簡訊模板
export function editSmsTemplate (params = {}) {
  return fetch({
    url: `/aliyunsms/template/modify`,
    method: 'post',
    params
  })
}

// 刪除簡訊模板
export function deleteSmsTemplate (id) {
  return fetch({
    url: `/aliyunsms/template/delete/${id}`,
    method: 'delete'
  })
}

// 群發資訊

// 新增簡訊任務
export function addTaskSms (params = {}) {
  return fetch({
    url: `/aliyunsms/task/add`,
    method: 'post',
    params
  })
}

// 群發任務詳情
export function taskSmsDetail (params = {}) {
  return fetch({
    url: `/aliyunsms/task/info`,
    method: 'get',
    params
  })
}

// 修改群發簡訊
export function editTaskSms (params = {}) {
  return fetch({
    url: `/aliyunsms/task/modify`,
    method: 'post',
    params
  })
}

// 撤銷刪除群發簡訊
export function deleteTaskSms (params = {}) {
  return fetch({
    url: `/aliyunsms/task/revoke`,
    method: 'post',
    params
  })
}
